import { render, staticRenderFns } from "./rectLoading.vue?vue&type=template&id=7b944954&scoped=true"
import script from "./rectLoading.vue?vue&type=script&lang=js"
export * from "./rectLoading.vue?vue&type=script&lang=js"
import style0 from "./rectLoading.vue?vue&type=style&index=0&id=7b944954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b944954",
  null
  
)

export default component.exports